import { UIAutocompleteItem, UIAutocompleteRowView, YES } from "uicore-ts"
import { RHColor } from "./RHColor"


export class RHAutocompleteRowView<T> extends UIAutocompleteRowView<T> {

    displayLabelForItem?: (item: UIAutocompleteItem<T>) => string

    constructor(elementID?: string) {

        super(elementID);

        (this as UIAutocompleteRowView<T>).configureWithObject({
            style: {
                cursor: "pointer",
                transition: "background-color 0.1s ease"
            }
        });

        this.titleLabel.configureWithObject({
            isSingleLine: YES,
            style: {
                fontSize: "0.9375rem",
                lineHeight: "1.5"
            }
        })

        this.colors = {
            titleLabel: {
                normal: RHColor.dark,
                hovered: RHColor.dark,
                highlighted: RHColor.dark,
                selected: RHColor.textWhite
            },
            background: {
                normal: RHColor.textWhite,
                hovered: RHColor.textWhite,
                highlighted: RHColor.textWhite,
                selected: RHColor.primary
            }
        }

    }


    override _updateLabelContent() {

        if (!this._item) {
            return
        }

        const label = this._displayLabelForCurrentItem()

        if (this._filterWords.length === 0) {
            this.titleLabel.text = label
            return
        }

        const escapedWords = this._filterWords.map(
            word => word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
        )
        const pattern = new RegExp(`(${escapedWords.join("|")})`, "gi")
        const highlighted = this._htmlEscapedString(label).replace(pattern, "<strong>$1</strong>")

        this.titleLabel.innerHTML = highlighted

    }


    _displayLabelForCurrentItem(): string {
        const item = this._item
        if (!item) {
            return ""
        }
        if (this.displayLabelForItem) {
            return this.displayLabelForItem(item)
        }
        return item.label
    }


    _htmlEscapedString(value: string): string {
        return value
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
    }


}
